var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-rounded-lg tw-bg-white tw-p-3",class:{
    'tw-shadow': _vm.shadow,
    'tw-border-1 tw-border-neutral-200': _vm.border,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }